module.exports = __webpack_public_path__ + "media/images/athletes/1983-31b3e053b764ca433729f148b1ca4ab6.png";